import { defineMessages } from '@jutro/locale';

export default defineMessages({
    selectPolicyTitle: {
        id: 'ml.gateway.views.account-detail.Select Policy',
        defaultMessage: 'Select Policy'
    },
    paymentAmountTitle: {
        id: 'ml.gateway.views.account-detail.Payment Amount',
        defaultMessage: 'Select One-Time Payment Amount'
    },
    paymentMethodTitle: {
        id: 'ml.gateway.views.account-detail.Payment Method',
        defaultMessage: 'Payment Method'
    },
    makePayment: {
        id: 'ml.gateway.views.account-detail.Make Payment',
        defaultMessage: 'Make Payment'
    },
    edit: {
        id: 'ml.gateway.views.account-detail.Edit',
        defaultMessage: 'Edit'
    },
    onetimePaymentAmount: {
        id: 'ml.gateway.views.account-detail.one-time payment amount',
        defaultMessage: 'one-time payment amount'
    },
    selectPolicyNextDescription: {
        id: 'ml.gateway.views.account-detail.selectPolicyNextDescription',
        defaultMessage: 'We\'ll need you to select {onetimePaymentAmount} next'
    },
    paymentMethod: {
        id: 'ml.gateway.views.account-detail.payment method',
        defaultMessage: 'payment method'
    },
    policyAmountNextDescription: {
        id: 'ml.gateway.views.account-detail.policyAmountNextDescription',
        defaultMessage: 'We\'ll need you to select a {paymentMethod} next'
    },
    getRequiredSignatures: {
        id: 'ml.gateway.views.account-detail.get required signatures',
        defaultMessage: 'get required signatures'
    },
    wellGetRequiredSignaturesNext: {
        id: 'ml.gateway.views.account-detail.We\'ll get required signatures next',
        defaultMessage: 'We\'ll {getRequiredSignatures} next'
    },
    processYourPayment: {
        id: 'ml.gateway.views.account-detail.process your payment',
        defaultMessage: 'process your payment'
    },
    wellProcessYourPaymentNext: {
        id: 'ml.gateway.views.account-detail.We\'ll process your paymen next',
        defaultMessage: 'We\'ll {processYourPayment} next'
    },
    failedToRemoveAccountHeader: {
        id: 'ml.gateway.views.account-detail.Failed to remove account',
        defaultMessage: 'Failed to remove account'
    },
    failedToRemoveAccountMessage: {
        id: 'ml.gateway.views.account-detail.Sorry we are not able to remove this account at this time',
        defaultMessage: 'Sorry we are not able to remove this account at this time'
    },
    processingPayment: {
        id: 'ml.gateway.views.account-detail.Processing Payment',
        defaultMessage: 'Processing Payment'
    },
    creditDebitCard: {
        id: 'ml.gateway.views.account-detail.Credit/Debit Card',
        defaultMessage: 'Credit/Debit Card'
    },
    bankAccount: {
        id: 'ml.gateway.views.account-detail.Bank Account',
        defaultMessage: 'Bank Account'
    },
    agencySweep: {
        id: 'ml.gateway.views.account-detail.Agency Sweep',
        defaultMessage: 'Agency Sweep'
    },
    agentInPerson: {
        id: 'ml.gateway.views.account-detail.In Person',
        defaultMessage: 'In Person'
    },
    agentPhone: {
        id: 'ml.gateway.views.account-detail.Over Phone',
        defaultMessage: 'Over Phone'
    },
    howIsPaymentBeingMade: {
        id: 'ml.gateway.views.account-detail.How is Payment being made?',
        defaultMessage: 'How is Payment being made?'
    },
    addNewAccount: {
        id: 'ml.gateway.views.account-detail.Add account',
        defaultMessage: 'Add account'
    },
    xEndingInX: {
        id: 'ml.gateway.views.account-detail.xEndingInX',
        defaultMessage: '{nickname} ending in {last4Digits}'
    },
    pendingPaymentWarning: {
        id: 'ml.common.component.MLSelectPolicyToPay.A payment is in process on your account. Making another payment could result in multiple withdrawals from your account.',
        defaultMessage: 'A payment is in process on your account. Making another payment could result in multiple withdrawals from your account.'
    },
    removeInstrumentSuccess: {
        id: 'ml.gateway.views.account-detail.x ending in x has been removed',
        defaultMessage: '{xEndingInX} has been removed'
    },
    invalidCreditCardError: {
        id: 'ml.gateway.views.account-detail.Selected Credit Card Is Expired. Please Update The Credit Card Information.',
        defaultMessage: 'Selected Credit Card Is Expired. Please Update The Credit Card Information.'
    },
    lessThanMinCardAmountError: {
        id: 'ml.gateway.views.account-detail.The minimum payment amount allowed for credit card is $1.00.',
        defaultMessage: 'The minimum payment amount allowed for credit card is $1.00.'
    },
    notSuccess: {
        id: 'ml.gateway.views.account-detail.Your payment in the amount of x was not successful.',
        defaultMessage: 'Your payment in the amount of {amount} was not successful.'
    },
    paymentProcessingError: {
        id: 'ml.gateway.views.account-detail.Please review your account information or try again using a different form of payment.',
        defaultMessage: '{notSuccess} Please review your account information or try again using a different form of payment.'
    }
});